import { useEffect } from "react";
import { useIsFetching } from "@tanstack/react-query";
import NProgress from "nprogress";

NProgress.configure({ showSpinner: false, speed: 400, minimum: 0.3 });

const NavigationProgress = () => {
  const loading = useIsFetching({
    predicate: (query) => query.state.fetchStatus === "fetching" && query.state.data === undefined,
  });

  useEffect(() => {
    if (loading > 0) NProgress.start();
    else NProgress.done();
  }, [loading]);

  return null;
};

export default NavigationProgress;
